import ioClient from 'socket.io-client';
import config from '~/config';
import { buildUrl } from './utilHelper';

export const openSocket = (namespace: string | null, options: any) => {
  if (!namespace) {
    namespace = config.SOCKET_NAMESPACE as string;
  }
  const url = buildUrl(config.API_URL as string, namespace);
  return ioClient(url, {
    transports: ['websocket'],
    secure: true,
    path: config.SOCKET_PATH,
    ...options,
  });
}

export const closeSocket = (client: any) => {
  if (!client) {
    return;
  }
  client.removeAllListeners();
  client.close();
}